import React, { useContext } from 'react';
import { context } from '@catalogo/ui-americanas-desktop-product-review/src/context';
import { FilterTag } from '@catalogo/ui-americanas-desktop-product-review/src/components/molecules';
import { FilterTagWrapper } from './Styled';
import { ButtonCleanFilter } from '../../../../../../desktop/product-review/src/components/atoms';

const FilterTagBox = () => {
  const { queryParam } = useContext<any>(context);

  if (!queryParam?.rating?.length && queryParam.badges == null) {
    return <></>;
  }
  return (
    <FilterTagWrapper className="product-review-filter-tag-box">
      <ButtonCleanFilter />
      <FilterTag fontSize={14} />
    </FilterTagWrapper>
  );
};
export default FilterTagBox;
export { FilterTagBox };
